function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _g;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import { Platform } from 'react-native';
import { createElement } from 'react';
var SvgUserPlus = function SvgUserPlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M18 14.667v2.666M16.666 16h2.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.02 13.332A13.554 13.554 0 0 0 12 13c-4.418 0-8 2.015-8 4.5S4 22 12 22c5.58 0 7.268-.98 7.778-2.416"
  }))));
};
if (Platform.OS === 'web') {
  var ForwardRefNativeSvgIcon = /*#__PURE__*/React.forwardRef(SvgUserPlus);
  SvgUserPlus = function SvgUserPlus(props, ref) {
    return /*#__PURE__*/createElement(ForwardRefNativeSvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  };
}
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserPlus);
export default ForwardRef;